import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PagerComponent } from '../paginator/pager.component';

/** AngularMaterial **/
import {
  MatSelectModule,
  MatButtonModule,
  MatIconModule,
  MatInputModule,
  MatToolbarModule,
  MatProgressBarModule,
  MatSnackBarModule,
  MatTabsModule,
  MatDialogModule,
  MatListModule,
  MatCardModule,
  MatExpansionModule,
  MatChipsModule
} from '@angular/material';
import { DesclassificarDialogComponent } from './desclassificar-dialog.component';
import { DesclassificarDetailComponent } from './desclassificar-detail.component';
import { DesclassificarButtonComponent } from './desclassificar-button.component';
import { OcorrenciaService } from '../ocorrencia/ocorrencia.service';
import { EstudoCabecalhoModule } from '../estudo-cabecalho/estudo-cabecalho.module';
import { DesclassificarVariosButtonComponent } from './desclassificar-varios-button.component';
import { DesclassificarVariosDetailComponent } from './desclassificar-varios-detail.component';

@NgModule({
  declarations: [
    DesclassificarDialogComponent,
    DesclassificarDetailComponent,
    DesclassificarButtonComponent,
    DesclassificarVariosButtonComponent,
    DesclassificarVariosDetailComponent
  ],
  exports: [
    DesclassificarDialogComponent,
    DesclassificarDetailComponent,
    DesclassificarButtonComponent,
    DesclassificarVariosButtonComponent,
    DesclassificarVariosDetailComponent
  ],
  imports: [
    FormsModule,
    CommonModule,
    EstudoCabecalhoModule,
    MatSelectModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatDialogModule,
    MatCardModule,
    MatListModule,
    MatToolbarModule,
    MatTabsModule,
    MatExpansionModule,
    MatChipsModule
  ],
  providers: [PagerComponent, OcorrenciaService],
  entryComponents: [ DesclassificarDialogComponent ]
})
export class DesclassificarModule {}
